import { CallState } from '../types';
import IWebPhoneService from '../IWebPhoneService';
import appManager from '@app/appManager';
import IAppLogger from '@app/lib/IAppLogger';

const handleCallAnswered = (
  webPhoneService: IWebPhoneService,
  updatedCallState: CallState,
  logger: IAppLogger,
) => {
  logger.info(
    `Call started: ${updatedCallState.remoteIdentity}, ${updatedCallState.callId}`,
    updatedCallState,
    webPhoneService,
  );

  appManager.events.emit('phone.call.answered', updatedCallState);
};

export default handleCallAnswered;
